import { useRef } from "react";
import { Avatar, Button, Field, Input, PhoneInput } from "../../ui";
import { mediaUrl } from "../../../utils/clientHeroTheme";
import ProfileSubscriptionPanel from "./ProfileSubscriptionPanel";
import cs from "../PatientPortal/clientApp.module.css";

export default function AdminOwnerProfileSettingsBody({
  profile,
  form,
  setForm,
  pwd,
  setPwd,
  billing,
  saving,
  pwdSaving,
  photoUploading,
  saveProfile,
  savePassword,
  uploadPhoto,
  showData = true,
  showBilling = true,
  showPassword = true,
}) {
  const photoInputRef = useRef(null);

  return (
    <>
      {showData ? (
        <>
          <button
            type="button"
            className={cs.profDataPhotoBtn}
            onClick={() => photoInputRef.current?.click()}
            disabled={photoUploading}
          >
            <Avatar
              name={profile?.full_name || form.full_name || "?"}
              src={mediaUrl(profile?.photo_url)}
              size="lg"
            />
            <span className={cs.profDataPhotoHint}>
              {photoUploading ? "Загрузка…" : "Нажмите, чтобы сменить фото"}
            </span>
          </button>
          <input
            ref={photoInputRef}
            type="file"
            accept="image/jpeg,image/png,image/webp"
            hidden
            onChange={uploadPhoto}
          />
          <Field label="ФИО">
            <Input
              value={form.full_name}
              onChange={(e) => setForm({ ...form, full_name: e.target.value })}
            />
          </Field>
          <Field label="Телефон">
            <PhoneInput
              value={form.phone || ""}
              onChange={(v) => setForm({ ...form, phone: v })}
            />
          </Field>
          <Field label="Email">
            <Input value={profile?.email || ""} readOnly />
          </Field>
          <Button type="button" onClick={saveProfile} disabled={saving}>
            {saving ? "Сохранение…" : "Сохранить"}
          </Button>
        </>
      ) : null}

      {showBilling && billing ? <ProfileSubscriptionPanel billing={billing} /> : null}

      {showPassword ? (
        <>
          <Field label="Текущий пароль">
            <Input
              type="password"
              value={pwd.current}
              onChange={(e) => setPwd({ ...pwd, current: e.target.value })}
            />
          </Field>
          <Field label="Новый пароль">
            <Input
              type="password"
              value={pwd.next}
              onChange={(e) => setPwd({ ...pwd, next: e.target.value })}
            />
          </Field>
          <Button
            type="button"
            onClick={savePassword}
            disabled={pwdSaving}
            variant="secondary"
          >
            {pwdSaving ? "…" : "Сменить пароль"}
          </Button>
        </>
      ) : null}
    </>
  );
}
